module.exports = __webpack_public_path__ + "Yfz3EKkuEAXohMTFW/agent-training-center_tips_for_success.png";